import React from 'react'

import { useAppSelector } from '../../../../../App/Hooks/reduxHooks'
import { Person } from '../../../../../App/store/features/person/IPerson'
import { calendarSettingsSelector } from '../../../../store/calendarSlice'
import { IAddedActivity } from '../../../Appointment/AddActivityViewSwitch/IAddActivity'
import { LabelSelect } from '../../LabelSelect/LabelSelect'
import { LabelSelectOption } from '../../LabelSelect/style'

interface IProps {
  personList: Person[]
  selectedActivity: IAddedActivity
  updateSelectedPersons: (
    addedIndex: number,
    personUuids: string[],
    activityUuid: string,
  ) => void
  selectedPersonName?: string
  addedIndex: number
  activityLabel: string
  customMargin: '0'
}

export const ActivityPersons = ({
  personList,
  selectedActivity,
  updateSelectedPersons,
  selectedPersonName,
  addedIndex,
  activityLabel,
  customMargin,
}: IProps) => {
  const editActivityPerson = (
    activityIndex: number,
    personUuid: string,
  ): void => {
    updateSelectedPersons(
      activityIndex,
      [personUuid],
      selectedActivity.appointmentActivityUuid || '',
    )
  }

  const { inActivePersonIds } = useAppSelector(calendarSettingsSelector)

  if (typeof inActivePersonIds === 'undefined') {
    return null
  }

  const PersonElementMap: JSX.Element[] = personList.map(person => (
    <LabelSelectOption
      value={person.personUuid}
      selected={
        selectedPersonName === person.firstName ||
        selectedActivity.personUuids.includes(person.personUuid)
      }
      onClick={() => editActivityPerson(addedIndex, person.personUuid)}
      disabled={inActivePersonIds.includes(person.id)}>
      {person.firstName}
    </LabelSelectOption>
  ))

  return (
    <LabelSelect
      onChange={e => editActivityPerson(addedIndex, e.target.value)}
      customMargin={customMargin}
      fieldLabel={activityLabel}
      fieldColor="#005cd9"
      leadingIcon="user"
      optionsArray={PersonElementMap}
    />
  )
}
